/**
 * @generated SignedSource<<7392071bb36802e1771fb25e0b3ac97c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BridgeViewer_node$data = {
  readonly content?: {
    readonly __typename: string;
    readonly url?: URIString;
  };
  readonly id: string;
  readonly name?: string;
  readonly " $fragmentType": "BridgeViewer_node";
};
export type BridgeViewer_node$key = {
  readonly " $data"?: BridgeViewer_node$data;
  readonly " $fragmentSpreads": FragmentRefs<"BridgeViewer_node">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BridgeViewer_node",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "url",
                  "storageKey": null
                }
              ],
              "type": "BridgeInterface",
              "abstractKey": "__isBridgeInterface"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "FolderItem",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};

(node as any).hash = "ed79c764648141ff0348c8b9cc645e5c";

export default node;
